import styled from '@emotion/styled';

const CustomInputLabel = styled.label(({ theme }) => ({
    ...theme.typography.p,
    color: theme.colors.tertiary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing.s,
    input: {
        maxWidth: '70px'
    }
}));

const CustomInput = styled.input(({ theme }) => ({
    ...theme.typography.pBold,
    color: theme.colors.tertiary,
    border: `1px solid ${theme.colors.tertiary}`,
    borderRadius: theme.borderRadius.s,
    marginTop: theme.spacing.xxs,
    padding: `${theme.spacing.xxxs} ${theme.spacing.xxs}`,
    outline: 'none',
    backgroundColor: theme.colors.backgroundColor,
    '&:placeholder': {
        color: theme.colors.tertiaryLighter,
        opacity: 0.5
    },
    '&:focus, &:active': {
        borderColor: theme.colors.primaryDark
    }
}));

const InfoText = styled.div(({ theme }) => ({
    ...theme.typography.pTiny,
    color: theme.colors.secondaryLight,
    marginTop: theme.spacing.xxxs
}));

function StyledInput({ label, placeholder, type, infoText, style, ...otherProps }) {
    return (
        <div>
            <CustomInputLabel>
                {label}
                <CustomInput type={type} placeholder={placeholder} {...otherProps} />
                {infoText ? <InfoText>{infoText}</InfoText> : ''}
            </CustomInputLabel>
        </div>
    );
}

export default StyledInput;
